module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-13.b8390e7e.png";